import { useEffect, useState } from 'react';
import { nextBookingMonth } from '@/lib/booking';

/**
 * The month in the hero availability badge, kept honest in the browser.
 *
 * The site is prerendered to static HTML, so anything computed during the
 * build freezes there until the next deploy. This badge went stale exactly
 * that way: a build in August baked in "September" and still said September
 * in October.
 *
 * It previously carried suppressHydrationWarning with a comment claiming the
 * value "recomputed on hydration". It does not. That prop tells React to
 * accept the server's text and skip the check, so the stale month was being
 * actively preserved rather than corrected -- silently, which is why it
 * survived two months.
 *
 * The honest fix is a two-pass render. First render uses __BUILD_BOOKING_MONTH__,
 * which Vite inlines as the same literal into the server and client bundles,
 * so hydration matches exactly. The effect then recomputes against the
 * visitor's actual clock and re-renders only when the two disagree -- which is
 * precisely when the build has gone stale across a month boundary.
 *
 * Crawlers and no-JS visitors still get the build-time month, which is correct
 * at deploy and never more than a month off.
 */
export function BookingMonth() {
  const [month, setMonth] = useState(__BUILD_BOOKING_MONTH__);

  useEffect(() => {
    setMonth(nextBookingMonth());
  }, []);

  return <>{month}</>;
}
